import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import { sxStyled } from './styles';

const FillterScales = ({ flightFilters }) => {
  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  const { scales, scaleSelected, scalesHandleChange } = flightFilters;

  return (
    <Grid item lg={12} sm={12} xs={12} sx={sxStyle.filterBox}>
      <Typography
        style={{
          fontSize: '15px',
          color: 'black',
          fontWeight: '600',
        }}
      >
        Escalas
      </Typography>
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {scales.map((scale, i) => (
          <FormControlLabel
            key={`${scale.name}-${i}`}
            sx={{
              ...sxStyle.formControlLabelRoot,
              '& .MuiFormControlLabel-label': {
                ...sxStyle.formControlLabel,
              },
              fontFamily: 'Open Sans',
            }}
            onClick={scalesHandleChange}
            value={scale.value}
            control={
              <Checkbox
                checked={scaleSelected === scale.value}
                name={scale.name}
                sx={{
                  fontFamily: 'Open Sans',
                  color: theme.tertiary,
                  '&.Mui-checked': { color: theme.tertiary },
                }}
              />
            }
            label={scale.name}
          />
        ))}
      </Box>

      <Divider sx={sxStyle.filterBoxDivider} />
    </Grid>
  );
};

export default FillterScales;
